import React from 'react';


const TimeField = (props) => {

    const {time} = props;
    let splitedTime = ['09', '00'];

    if (time) {
        splitedTime = time.split(':');
    }
    
    let hr = splitedTime[0] ? Number(splitedTime[0]) : 9;
    let mn = Number(splitedTime[1]) || 0;
    let amPm = 'AM'; 

    if (hr >= 12) {
        hr -= 12;
        amPm = 'PM';
    } 
    hr = hr === 0 ? 12 : (hr < 0) ? 9 : hr;

    const handleOfficeTimeChange = (e) => {
        const {name, value} = e.target;
        if (name === 'hr') {
            hr = Number(value);
            if (amPm === 'PM') {
                hr += 12;
                if (hr === 24) {
                    hr = 12;
                }
            } else {
                if (hr === 12) {
                    hr = 0;
                }
            }
        } else if (name === 'mn') {
            mn = Number(value);
        } else {
            if (value === 'AM') {
                if (hr === 12) {
                    hr = 0;
                }
            } else {
                hr += 12;
                if (hr === 24) {
                    hr = 12;
                }
            }
        }
        let updatedTime = `${`0${hr}`.slice(-2)}:${`0${mn}`.slice(-2)}`;
        props.onValueChange(updatedTime);
    }

    const renderHourOptions = () => {
        let hourList = [];

        for(let hour=1; hour <= 12; ++hour) {
            hourList.push(
                <option key={hour} value={hour}>{`0${hour}`.slice(-2)}</option>
            );
        }
        return hourList;
    }

    const renderMinuteOptions = () => {
        let minuteList = [];

        for(let minute=0; minute < 60; minute += 5)  {
            minuteList.push(
                <option key={minute} value={minute}>{`0${minute}`.slice(-2)}</option>
            );
        }
        return minuteList;
    }
    
    return (
        <div className={`input-group input-group-${props.size} ${props.className}`}>
            <select className={`form-control form-control-${props.size}`}
                name="hr" 
                onChange={handleOfficeTimeChange}
                value={hr}
                disabled={props.disabled}
            >
                {renderHourOptions()}
            </select>
            <div className="input-group-append">
                <select className={`form-control form-control-${props.size}`}
                    name="mn" 
                    onChange={handleOfficeTimeChange}
                    value={mn}
                    disabled={props.disabled}
                >
                    {renderMinuteOptions()}
                </select>
            </div>
            <div className="input-group-append">
                <select className={`form-control form-control-${props.size}`}
                    name="amPm" 
                    onChange={handleOfficeTimeChange}
                    value={amPm}
                    disabled={props.disabled}
                >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                </select>
            </div>
        </div>
    );
}

export default TimeField;



// WEBPACK FOOTER //
// ./src/components/common/Time.js